import { render, staticRenderFns } from "./GlobalSports.vue?vue&type=template&id=b1312d5c&scoped=true"
import script from "./GlobalSports.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSports.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalSports.vue?vue&type=style&index=0&id=b1312d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1312d5c",
  null
  
)

export default component.exports